import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Panel, Accordion } from 'react-bootstrap';
import { ClientDetails, ClientContacts, InteractionsList } from './';
import { Tab, Nav, Row, Col, NavItem, NavDropdown, MenuItem } from 'react-bootstrap';
import {connect} from 'react-redux';
import * as Actions from 'actions';

class ClientInteractions extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { address, name, phone, last_updated, _id, date_added } = this.props.client;

    return (
      <div className="row">
        <div className="col-xs-12 col-md-4 col-lg-3">
          <ClientDetails client={this.props.client} />
          <ClientContacts />
        </div>
        <div className="col-xs-12 col-md-8 col-lg-9 animated fadeInDown">
          <Tab.Container id="InteractionsView" defaultActiveKey="ActiveTasks">
            <Row className="clearfix">
              <Col sm={12}>
                <Nav bsStyle="tabs">
                  <NavItem eventKey="ActiveTasks">
                    <i className="fa fa-phone"></i> Interactions
                  </NavItem>
                </Nav>
              </Col>
              <Col sm={12}>
                <Tab.Content animation>
                  <Tab.Pane eventKey="ActiveTasks">

                    <InteractionsList height="500px" enableCreate />

                  </Tab.Pane>
                </Tab.Content>
              </Col>
            </Row>
          </Tab.Container>
        </div>
      </div>

    );
  }
}

ClientInteractions.propTypes = {
  client : PropTypes.object
}

const mapStateToProps = ({ client }) => ({ client });

export default connect(mapStateToProps, Actions)(ClientInteractions);



// WEBPACK FOOTER //
// ./src/browser/components/client/client-interactions.js